<template>
  <footer class="app-footer">
    <div class="app-footer__inner">
      <!-- The stock logo's wordmark is black, which disappears on the footer's
           near-black bar — taxpod_logo_dark.png is the same asset with its dark
           neutrals inverted (same file the login navbar uses in dark mode). -->
      <img
        src="/images/taxpod_logo_dark.png"
        alt="taxPOD"
        class="app-footer__logo"
      />

      <div class="app-footer__text">
        <div class="app-footer__copy">© {{ year }} YYC GST CONSULTANTS SDN. BHD. (Malaysia)</div>
        <div class="app-footer__meta">
          <span>HRDC System</span>
          <span class="app-footer__sep">·</span>
          <span>v{{ $version }}</span>
          <span class="app-footer__sep">·</span>
          <span>Internal Use Only</span>
          <span class="app-footer__sep">·</span>
          <a
            class="app-footer__link"
            href="https://taxpod.atlassian.net/servicedesk/customer/portal/1"
            target="_blank"
            rel="noopener noreferrer"
            >Support</a
          >
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  data: () => ({
    year: 2026,
  }),
};
</script>

<style scoped>
/* The footer is dark by design in BOTH themes — it is the one surface that does
   not follow the page ramp, so there is no .dark-mode companion block here.

   This block is the FLAT bar, which is what the five guest pages render. Inside
   the two console layouts the same element is a floating panel — inset, rounded,
   rimmed, lifted — and that geometry lives in theme-glass.css §2 (search
   "THE FOOTER"), scoped to .layout-main / .dev-main so it cannot reach the guest
   pages. If a padding or radius here looks unused in the console, that is why:
   the console rules outrank it at (1,3,0) against this block's (0,2,0). */
.app-footer {
  background: #082028;
  color: #cfd8dd;
  font-family: "Lato", "Segoe UI", -apple-system, BlinkMacSystemFont, sans-serif;
  /* Carried here rather than in each host: the guest pages put the footer in a
     100vh flex column (must not shrink), and on pages with absolutely
     positioned decoration it has to win the paint order. */
  flex-shrink: 0;
  position: relative;
  z-index: 5;
}

.app-footer__inner {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 44px;
}

.app-footer__logo {
  height: 26px;
  width: auto;
  object-fit: contain;
  flex-shrink: 0;
}

.app-footer__text {
  min-width: 0;
  line-height: 1.5;
}

.app-footer__copy {
  font-size: 0.78rem;
  font-weight: 600;
  color: #ffffff;
}

.app-footer__meta {
  font-size: 0.74rem;
  color: #8fa3ab;
}

.app-footer__sep {
  margin: 0 6px;
  color: #4a6069;
}

.app-footer__link {
  color: #38bdf8;
  text-decoration: none;
  font-weight: 600;
}

.app-footer__link:hover {
  text-decoration: underline;
}

@media (max-width: 599px) {
  .app-footer__inner {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding: 14px 16px;
  }

  .app-footer__sep {
    margin: 0 4px;
  }
}
</style>
